// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect, useRef } from 'react';
import Slide from './Slide';
import styles from './Testimonial.module.css';
import testimonialData from './TestimonialData';
import useIsInViewportOnce from '../../utils/hooks/useIsInViewportOnce';

const Testimonial = () => {
  const sectionRef = useRef();
  const isInViewportOnce = useIsInViewportOnce(sectionRef);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const lastIndex = testimonialData.length - 1;
    if (index < 0) {
      setIndex(lastIndex);
    }
    if (index > lastIndex) {
      setIndex(0);
    }
  }, [index]);

  useEffect(() => {
    const slider = setInterval(() => {
      setIndex(index + 1);
    }, 6000);

    return () => clearInterval(slider);
  }, [index]);

  return (
    <section id="clients" className={styles.testimonial} ref={sectionRef}>
      <div className="container">
        <div
          className={`${styles.heading} ${
            isInViewportOnce ? 'useSlideInLeft' : 'useSlideInLeftEnter'
          }`}
        >
          <h4>QUE DICEN DE MI TRABAJO </h4>
          <h1>Testimonios</h1>
        </div>
        <div className={styles.pagination}>
          {testimonialData.map((key) => (
            <span
              key={key.id}
              className={`${styles['pagination-dot']} ${
                key.id === index ? styles['pagination-dot--active'] : ''
              }`}
            />
          ))}
        </div>
        <div className={styles.slider}>
          {testimonialData.map((data) => (
            <Slide
              data={data}
              valueIndex={data.id}
              key={data.id}
              index={index}
              dataLength={testimonialData.legth}
            />
          ))}

          <div className={styles.slideButtons}>
            <button
              title="Slide anterior"
              name="slide-anterior"
              className={styles.sliderBtn}
              type="button"
              onClick={() => setIndex(index - 1)}
              aria-label="Slide anterior"
            >
              <i className="fas fa-arrow-left" />
            </button>
            <button
              title="Slide siguiente"
              name="slide-siguiente"
              className={styles.sliderBtn}
              type="button"
              onClick={() => setIndex(index + 1)}
              aria-label="Slide siguiente"
            >
              <i className="fas fa-arrow-right" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
